// src/redux/reducers/gate/gateReducer.js
const initState = {
  gate: {},
  gates: [],
  gateCount: 0,
  
  // Permanent Access states
  permanentAccessList: [],
  permanentAccessCount: 0,
  permanentAccessLoading: false,
  
  // socket-related states
  isConnected: false,
  connectionError: null,
  lastMemberAccess: null,
  recentAccesses: [],
  connectedClients: 0
};

const GateReducer = (state = initState, action) => {
  switch (action.type) {
    case "SET_GATE_DATA":
      return {
        ...state,
        gate: action.payload.data,
      };
      
    case "SET_GATE_COUNT":
      return {
        ...state,
        gateCount: action.payload.data,
      };
      
    case "SET_GATES_DATA":
      return {
        ...state,
        gates: action.payload.data,
      };
      
    // socket-related cases
    case "SET_GATE_CONNECTION_STATUS":
      return {
        ...state,
        isConnected: action.payload.data,
        // Clear connection error when successfully connected
        connectionError: action.payload.data ? null : state.connectionError,
      };
      
    case "SET_CONNECTION_ERROR":
      return {
        ...state,
        connectionError: action.payload.data,
        // Set connected to false when there's an error
        isConnected: false,
      };
      
    case "SET_MEMBER_ACCESS":
      return {
        ...state,
        lastMemberAccess: action.payload.data,
        recentAccesses: [
          action.payload.data,
          ...state.recentAccesses.slice(0, 4)
        ],
      };
      
    case "SET_CONNECTED_CLIENTS":
      return {
        ...state,
        connectedClients: action.payload.data,
      };
      
    // Permanent Access cases
    case "SET_PERMANENT_ACCESS_DATA":
      return {
        ...state,
        permanentAccessList: action.payload.data,
      };
      
    case "SET_PERMANENT_ACCESS_COUNT":
      return {
        ...state,
        permanentAccessCount: action.payload.data,
      };
      
    case "SET_PERMANENT_ACCESS_LOADING":
      return {
        ...state,
        permanentAccessLoading: action.payload.data,
      };
      
    default:
      return { ...state };
  }
};

export default GateReducer;